export const userRoles = [
  {entityType: "ORGANISATION", id: '2', roleName: 'MEMBER' , value: '2', label: 'MEMBER'},
  {entityType: 'ORGANIZATION', id: '1', roleName: 'SUPER_ADMIN', value: '1', label: 'SUPER_ADMIN'}
]